import { render, staticRenderFns } from "./ProductPeriodEdit.vue?vue&type=template&id=5304b983&scoped=true&"
import script from "./ProductPeriodEdit.vue?vue&type=script&lang=js&"
export * from "./ProductPeriodEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5304b983",
  null
  
)

export default component.exports